import { render } from "./OAuthAuthorize.vue?vue&type=template&id=776da254&scoped=true"
import script from "./OAuthAuthorize.vue?vue&type=script&lang=js"
export * from "./OAuthAuthorize.vue?vue&type=script&lang=js"

import "./OAuthAuthorize.vue?vue&type=style&index=0&id=776da254&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-776da254"]])

export default __exports__